const PATH = 'fe.components.learning_resources.recommendation_banner';

const messages = {
  title: {
    key: `${PATH}.title`,
    defaultValue: 'Resource Recommendations'
  },
  emptyDescription: {
    key: `${PATH}.empty_description`,
    defaultValue:
      'No observation scores found. Please navigate back to "All Resources" using the dropdown above to browse manually.'
  },
  descriptionBefore: {
    key: `${PATH}.description_before`,
    defaultValue:
      "We've selected these resources to support your growth in the dimension"
  },
  descriptionAfter: {
    key: `${PATH}.description_after`,
    defaultValue: ', based on your most recent observation on {{date}}.'
  },
  howDetermined: {
    key: `${PATH}.how_determined`,
    defaultValue: 'How is this determined?'
  }
};

export default messages;
